<template>
  <div class="box">
    <div class="main">
        为了保证患者就诊资料安全，查看检查检验报告需要进行人脸识别认证，确保本人认证。
    </div>
    <div class="footer">
      <van-button  plain type="info" :round="true" size="small">取消</van-button>
      <van-button type="info" :round="true" size="small" @click="goC">去认证</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reportIndex',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    onClickLeft() {},
    goC() {
      this.$router.push('certification')
    }
  }
}
</script>
<style scoped>
.box{
    background-color: rgb(242, 248, 253);
    width: 100vw;
    height: 100vh;

}
.header /deep/ .van-nav-bar .van-icon {
  color: rgb(102, 102, 102);
}
.main{
    font-size: 14px;
    padding: 10px 15px 20px 15px;
    background-color: #ffffff;
    line-height: 28px;
}

.footer {
  width: 100vw;
  display: flex;
  background-color: rgb(242, 248, 253);
  padding-top: 10px;
}
.footer button {
  width: calc(100% - 40px);
  margin: 10px 20px 10px 20px;
}
</style>
